import { Controller } from "@hotwired/stimulus"

// Manages the marking position dropdown with standard + custom positions.
// When "+ Ajouter une position personnalisée" is selected, switches to a text input
// and saves the custom position to the customer via API.
// Connects to data-controller="erp--position-selector"
export default class extends Controller {
  static targets = ["positionSelect", "positionInput", "labelHidden"]

  static values = {
    saveUrl: String
  }

  positionChanged() {
    const select = this.positionSelectTarget
    if (select.value === "__custom__") {
      // Switch to text input mode
      select.classList.add("hidden")
      this.positionInputTarget.classList.remove("hidden")
      this.positionInputTarget.focus()
    } else {
      // Update the hidden label field
      this.labelHiddenTarget.value = select.value
    }
  }

  async confirmCustomPosition() {
    const input = this.positionInputTarget
    const label = input.value.trim()
    if (!label) return

    // Update the hidden label field
    this.labelHiddenTarget.value = label

    // Save to customer via API
    if (this.saveUrlValue) {
      try {
        const response = await fetch(this.saveUrlValue, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
          },
          body: JSON.stringify({ label })
        })

        if (response.ok) {
          const data = await response.json()
          this.#addCustomOptionToAllSelects(label, data.positions)
        }
      } catch (error) {
        console.warn("[position-selector] Failed to save custom position:", error)
      }
    }

    // Switch back to select mode with the new value
    this.#addOptionToSelect(this.positionSelectTarget, label)
    this.positionSelectTarget.value = label
    this.positionSelectTarget.classList.remove("hidden")
    input.classList.add("hidden")
    input.value = ""
  }

  cancelCustomPosition() {
    this.positionInputTarget.classList.add("hidden")
    this.positionSelectTarget.classList.remove("hidden")
    this.positionSelectTarget.value = ""
    this.labelHiddenTarget.value = ""
  }

  // ── Private ──────────────────────────────────────────────────

  #addOptionToSelect(select, label) {
    // Add before the custom option separator
    const customOption = select.querySelector("option[value='__custom__']")
    if (!customOption) return

    // Check if already exists
    if ([...select.options].some(o => o.value === label)) return

    const separator = customOption.previousElementSibling
    const opt = document.createElement("option")
    opt.value = label
    opt.textContent = label

    if (separator && separator.disabled) {
      separator.before(opt)
    } else {
      customOption.before(opt)
    }
  }

  #addCustomOptionToAllSelects(label, _allPositions) {
    // Update all position selects in the form (other zones of the same item + future items)
    const form = this.element.closest("form")
    if (!form) return

    form.querySelectorAll("[data-erp--position-selector-target='positionSelect']").forEach(select => {
      this.#addOptionToSelect(select, label)
    })
  }
}
